export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AML Check"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter an address and select a blockchain — we'll perform a quick screening."])}
}